import React, {useEffect,useState} from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Chart from 'react-apexcharts';
import apiurl from '../Api';
import './css/index.css';
function AppDashboard(){

const  {aid}= useParams();
const [staff, setStaff] = useState([]);
const [groupByLocation, setGroupByLocation] = useState({});
const [groupByProfile, setGroupByProfile] = useState({});
const [person, setPerson]= useState([]);
 const [selectedExp, setExperience] = useState(null);
 const [metaData, setMetaData] = useState({
  total: 0,
  appname: '',
  okay:false,
  types:0,
  icon:''
});

const fetchData = async () => {
  const response = await axios.get(apiurl+'appDash.php?subdomain=react&aid='+aid); // Replace with your API endpoint
   setStaff(response.data.staff);
   setGroupByLocation(response.data.glocation);
   setGroupByProfile(response.data.gprofile);
   setExperience(response.data.gexper);

  setPerson(response.data.person);

setMetaData({
  total: response.data.total,
  appname: response.data.appname,
  okay:response.data.okay,
  types:response.data.types,
  icon:response.data.icon
});
};


useEffect(() => {
  document.title = "App Dashboard | MERAQUI";
       fetchData();
}, []);
const targetYear = 2025;
const targetMonth = 7; // August

// Format date safely
const formatDate = (date) => {
  if (!(date instanceof Date) || isNaN(date)) return null;
  return date.toISOString().split('T')[0];
};

// Step 1: Build full dates of August
const daysInMonth = new Date(targetYear, targetMonth + 1, 0).getDate();
const fullDateArray = [];

for (let day = 1; day <= daysInMonth; day++) {
  const date = new Date(targetYear, targetMonth, day);
  fullDateArray.push({
    x: date.getTime(),
    dateStr: formatDate(date),
    y: 0
  });
}

// Step 2: Prepare your actual data (from staff)
const rawData = Array.isArray(staff)
  ? staff
      .filter(item => item.dates) // ignore missing/null
      .map((item) => {
        const parsedDate = new Date(item.dates);
        const dateStr = formatDate(parsedDate);
        return dateStr ? { dateStr, y: item.total } : null;
      })
      .filter(Boolean) // remove any nulls
  : [];

// Step 3: Merge
const mergedData = fullDateArray.map((item) => {
  const match = rawData.find((d) => d.dateStr === item.dateStr);
  return {
    x: item.x,
    y: match ? match.y : 0
  };
});



const profileLabels = Array.isArray(groupByProfile)
  ? groupByProfile.map(item => item.profile)
  : [];

const profileData = Array.isArray(groupByProfile)
  ? groupByProfile.map(item => item.total)
  : [];

const locationLabels = [
  "Ahmedabad", "AJMER", "Bangalore", "Chennai", "Delhi",
  "Hyderabad", "JODHPUR", "Kolkata", "Mumbai", "Pune"
];

const locationData = [7, 1, 26, 11, 3, 12, 1, 17, 6, 18];

  
const experienceLabels = selectedExp?.map((item) => item.exp) || [];
const experienceData = selectedExp?.map((item) => item.total) || [];

return(
<>
    {/* MAIN-CONTENT */}

            <div className="main-content app-content">

                
                <div className="container-fluid">
                

                {/* Start::row-1 */}
                    <div className="row">

 <div class="col-xx-4 col-xl-4 col-lg-6 mt-4">
    <div class="card custom-card">
        <div class="card-body">
            <div class="d-flex justify-content-between">
                <div class="me-1">
                    <h6 class="fs-19 mg-b-3">{metaData.appname}</h6>
                    <p class="fs-14 fw-semibold badge bg-primary-transparent" style={{marginBottom:'0px',padding:'10px'}}>Total Candidate : {metaData.total}</p>
                </div>
                <div class="min-w-fit-content">
                    <div class="avatar bg-primary-transparent"><i class={metaData.icon+" fs-28"}></i></div>
                </div>
            </div>
           
        </div>
    </div>
</div>
                        
                       <div class="col-xxl-12 col-xl-12 mt-2">
                            <div class="card custom-card">
                                <div class="card-header">
                                    <div class="card-title">Candidate Date Wise Trend</div>
                                </div>
                                <div class="card-body">
<Chart
  options={{
    chart: {
      id: 'trend',
      type: 'line',
      height: 250,
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    colors: ['#845adf'],
    stroke: {
      curve: 'straight',
      width: 3,
    },
    markers: {
      size: 5, // 👈 Size of the bullet
      strokeWidth: 2,
      strokeColors: '#fff',
      fillOpacity: 1,
      shape: 'circle',
    },
    grid: {
      borderColor: '#f2f5f7',
    },
    xaxis: {
      type: 'datetime',
      tickAmount: mergedData.length, // 👈 force to show all ticks (one for each date)
      labels: {
        show: true,
        rotate: -45,
        style: {
          colors: '#8c9097',
          fontSize: '11px',
          fontWeight: 600,
        },
        datetimeFormatter: {
          day: 'dd MMM', // 👈 Only date format
        },
      },
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy',
      },
    },
    yaxis: {
      labels: {
        show: true,
        style: {
          colors: '#8c9097',
          fontSize: '11px',
          fontWeight: 600,
        },
      },
    },
  }}
  series={[{ name: 'Candidates', data: mergedData }]}
  type="line"
  height={250}
/>



                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-6 col-xl-6">
                            <div class="card custom-card">
                                <div class="card-header">
                                    <div class="card-title">Candidates by Profile</div>
                                </div>
                                <div class="card-body">
   <Chart
      options={{
        chart: { type: 'bar', height: 350 },
        plotOptions: {
          bar: { distributed: true, horizontal: false, columnWidth: '55%', endingShape: 'rounded' },
        },
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: { categories: profileLabels },
      }}
      series={[{ data: profileData }]}
      type="bar"
      height={350}
    />

                                </div>
                            </div>
                        </div>

                        <div className='col-xxl-6'>
                            <div className="card custom-card">
  <div className="card-header">
    <h5 className="card-title">Candidates by Location</h5>
  </div>
  <div className="card-body">
      <Chart
      options={{
        labels: locationLabels,
        legend: { position: 'bottom' },
        colors: ['#845adf', '#f7b731', '#ff7f50', '#1e90ff', '#e74c3c'],
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val.toFixed(1)}%`,
        },
      }}
      series={locationData}
      type="pie"
      width="60%"
    />
  </div>
</div>

                        </div>

                        <div className='col-xxl-6'>
                            <div className="card custom-card">
  <div className="card-header">
    <h5 className="card-title">Candidates by Experience</h5>
  </div>
  <div className="card-body">
  <Chart
      options={{
        chart: { type: 'bar', height: 350 },
        plotOptions: { bar: { borderRadius: 4, horizontal: true } },
        dataLabels: { enabled: false },
        xaxis: {
          categories: experienceLabels,
          labels: { style: { colors: '#8c9097', fontSize: '14px' } },
        },
        colors: ['#845adf'],
        grid: { borderColor: '#f2f5f7' },
      }}
      series={[{ name: 'Candidates', data: experienceData }]}
      type="bar"
      height={350}
    />
  </div>
</div>

                        </div>
                     {(metaData.types == 1 || metaData.okay) && ( 
                      <>
                        <div className="col-xxl-6 col-xl-12">
                                 <div className="card custom-card overflow-hidden">
                                        <div className="card-header justify-content-between">
                                            <div className="card-title">
                                                Candidate Add by User
                                            </div>
                                        </div>
                                        <div className="card-body p-0">
                                            <ul className="list-group list-group-flush" id="recent-jobs">
                                                 {person.map((pro, index) => (
                                                <li className="list-group-item border-top-0 border-start-0 border-end-0">
                                                    <a href="javascript:void(0);">
                                                        <div className="d-flex align-items-center">
                                                            <div className="me-2 lh-1">
                                                                <span className="avatar avatar-md avatar-rounded bg-primary-transparent">
                                                                   {pro.name?.charAt(0).toUpperCase()}
                                                                </span>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <p className="mb-0 fw-semibold">{pro.name.toUpperCase()}</p>
                                                            </div>
                                                            <div className="text-end">
                                                                <p className="mb-0 fs-15">{pro.total}</p>
                                                            </div>
                                                        </div>
                                                    </a>
                                                </li>
                                                 ))}
                                            </ul>
                                        </div>
                                    </div>
                              
                        </div>
                    </>
                     )}
                    </div>
                    {/*End::row-1 */}

                </div>


            </div> 
            {/* END MAIN-CONTENT */}
</>
);
}

export default AppDashboard;